module.exports = __webpack_public_path__ + "img/overdueAddress.8ac4ca65.svg";